import LaunchIcon from '@mui/icons-material/Launch';
import { useRecordContext } from 'react-admin';

const MyUrlField = ({ source }: { source: string | undefined }) => {
  const record = useRecordContext();
  return record ? (
    <a href={record[source ?? '']} style={{ textDecoration: 'none' }}>
      {record[source ?? '']}
      <LaunchIcon sx={{ width: '0.5em', height: '0.5em', paddingLeft: 2 }} />
    </a>
  ) : null;
};

export default MyUrlField;
